import React from 'react';
import { Dropdown } from 'semantic-ui-react';
import _ from 'underscore';

const prepareCompaniesOptions = (list) => {
    return _.map(list, (item) => {
        return { text: item.companyName, value: item.companyId}
    })
};

const ClinicListFilterByCompany = (props) => {
    const companiesOptions = prepareCompaniesOptions(props.user.companies);
    const updateFilterOptions = (e, { value}) => {
        props.updateClinicFilterOptions({filterByType: null, filterByArea: null, filterByCompany: value});
    }
    return (
        <Dropdown 
            placeholder='Select Company' 
            onChange={updateFilterOptions}
            fluid 
            search
            selection 
            options={companiesOptions} 
            value={props.filterOptions.filterByCompany}
        />
    );
}

export default ClinicListFilterByCompany;